import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../img/logo.svg'
import _imports_1 from '../img/defaultUser.svg'
import _imports_2 from '../img/avatar.svg'
import _imports_3 from '../img/message.svg'
import _imports_4 from '../img/phone.svg'
import _imports_5 from '../img/time.svg'


const _withScopeId = n => (_pushScopeId("data-v-19bb56ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aside_top_wrapper" }
const _hoisted_2 = { class: "aside__top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "aside__top--right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "damand" }, null, -1))
const _hoisted_7 = { class: "toPay" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  style: {"display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "defaultImg",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "userInfo" }
const _hoisted_15 = { class: "profile" }
const _hoisted_16 = { class: "topInfo" }
const _hoisted_17 = { class: "basicInfo" }
const _hoisted_18 = { class: "account" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "img-style"
}, null, -1))
const _hoisted_20 = { class: "label" }
const _hoisted_21 = { class: "content omit overflow" }
const _hoisted_22 = { class: "account" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "img-style"
}, null, -1))
const _hoisted_24 = { class: "label" }
const _hoisted_25 = { class: "content" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["src"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "defaultImg",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconSetWidth" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "camera" })
], -1))
const _hoisted_32 = { class: "bottomInfo" }
const _hoisted_33 = {
  class: "profile",
  style: {"padding":"32px 0 0 0"}
}
const _hoisted_34 = { class: "devices" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "img-style"
}, null, -1))
const _hoisted_36 = {
  class: "label",
  style: {"min-width":"92px"}
}
const _hoisted_37 = { class: "content" }
const _hoisted_38 = { class: "devices" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "img-style"
}, null, -1))
const _hoisted_40 = { class: "label" }
const _hoisted_41 = { class: "content" }
const _hoisted_42 = { class: "devices" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "img-style"
}, null, -1))
const _hoisted_44 = { class: "label" }
const _hoisted_45 = { class: "content" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "logoutIcon" }, null, -1))

import {
  computed,
  defineComponent,
  PropType,
  reactive,
  ref,
  onUnmounted,
  toRefs,
  watch,
  onMounted,
} from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import screenfull from "screenfull";
import { createRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { ElMessage } from "element-plus";
import { signout } from "@/api/login";
import NAVLEFT from "../navLeft/navLeft.vue";
import ChangeAvator from "./ChangeAvator.vue";
import ChangeName from "./ChangeName.vue";
import { dateFormat, gaEvent } from "@/utils/format";
import languageChange from "@/components/whatsapp/languageChange.vue";
import { emptyDataApi, unbindAndEmptyDataApi } from "@/api/devices/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'AsideTop',
  setup(__props) {

const store = useStore();
const router = useRouter();
const nameShow = ref(true);
const email = localStorage.getItem("email");
const userInfo = computed(() => store.state.userInfo);
const deviceInfo = computed(() => store.state.deviceInfo);
const expired = computed(() => store.state.expired);
const isDemoRef = computed(() => !store.state.isVibe); // 判断是否是demo演示
const { t } = useI18n();

const subscripts = computed(() => {
  return store.state.subscripts;
});

const subscriptsIsNull = computed(() => {
  return subscripts && subscripts.value.begins_at ? false : true;
});

// 等账号体系权限弄好之后，就可以直接取subscripts中的数据，但是无权限直接不返回subscripts，现在都是不返回subscripts
// start
let boundedDevice = ref();

let restDevice = ref();
let expiration = ref();

// 避免刷新页面之后，页面的数据会销毁
onMounted(() => {
  // console.log('homehome')

  let arr;
  let data = new Date().getTime();
  // if (deviceInfo.value !== null) {
  if (deviceInfo.value.length > 0) {
    arr = deviceInfo.value.map((item: any) => {
      if (!item.apple_id) {
        if (item.model) {
          return item.model;
        } else {
          return item.name;
        }
      } else {
        return item.apple_id
      }
    });
    boundedDevice.value = arr.join("、");
  } else {
    boundedDevice.value = 0;
  }

  store.commit("setBoundedDevice", boundedDevice.value);

  restDevice.value = subscripts && subscripts.value.total_effective_pit
  expiration.value = dateFormat(
    subscripts.value.expires_at,
    "YYYY-MM-DD HH:mm"
  );
});
// 为了在获取玩用户信息之后立马拿到个人中心展示信息，需要去对个人信息做监听
// 且要将需要展示的数据变成响应式
watch(
  // () => store.state.userInfo,
  [userInfo, subscripts, isDemoRef],
  () => {
    let arr;
    // console.log('demo~')

    // if (deviceInfo.value !== null) {
    if (deviceInfo.value.length > 0) {
      arr = deviceInfo.value.map((item: any) => {
        if (!item.apple_id) {
          if (item.model) {
            return item.model;
          } else {
            return item.name;
          }
        } else {
          return item.apple_id
        }
      });
      boundedDevice.value = arr.join("、");
    } else {
      boundedDevice.value = 0;
    }
    store.commit("setBoundedDevice", boundedDevice.value);
    restDevice.value = subscripts && subscripts.value.total_effective_pit
    expiration.value =
      subscripts && subscripts.value.expires_at
        ? dateFormat(subscripts.value.expires_at, "YYYY-MM-DD HH:mm")
        : "--";
  }
);

// end
let state: any = reactive({
  loginStatus: computed(() => {
    store.state.loginStatus;
  }),
});

const gotoRoute = (name: any) => {
  router.push({ name });
};
// 控制全屏展示
let full = () => {
  screenfull.isEnabled && screenfull.toggle();
};

const showUser = () => {
  gaEvent("Account_Page", {
    event_category: "Personal_Center",
    event_label: "None",
  });
};
const userNameBlur = () => { };
const clickModify = ref(false);
const clickAvatar = ref(false);
const modifyName = () => {
  clickModify.value = true;
  gaEvent("UserName_Change", {
    event_category: "Personal_Center",
    event_label: "None",
  });
};
const showAvatar = () => {
  clickAvatar.value = true;
  gaEvent("Head_Change", {
    event_category: "Personal_Center",
    event_label: "None",
  });
};
const saveAvatar = () => {
  clickAvatar.value = false;
};
const saveUserName = (params: any) => {
  clickModify.value = false;
};
let loginOut = () => {
  // console.log('loginOut isDemoRef.value', isDemoRef.value);
  gaEvent("Exit_Login", {
    event_category: "Personal_Center",
    event_label: "None",
  });
  store.commit("setBoundImg", false);
  store.commit("setDefaultMenu", null);
  // 如果用户退出前选择的是addDevice，在退出前清空，使用户下次进入选中第一个设备
  store.commit("setClickGoPay", false);
  store.commit("setExpired", false);
  store.commit("setAutoRenew", false);

  if (isDemoRef.value) {
    // 如果当前token是demo的token，则不调取退出登录接口，直接进行退出操作
    try {
      ElMessage.success(t("logoutSucceeded"));
      localStorage.removeItem("authorization");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("user_id");
      router.push({ path: "/login" });
      store.commit("setLoginStatus", false);
      localStorage.removeItem("token");
      // 退出登录时重置demo和hash字段
      store.commit("setIsDemo", null);
      store.commit("setHashValue", null);
      // 清空vuex的缓存
      store.commit("getUserInfo", {});
      store.commit("getDeviceInfo", []);
      store.commit("setSubscripts", {});
      store.commit("setCurrentDeviceInfo", {});
      store.commit("setCurrentDeviceId", 0);
      // router.push('/login')
      return;
    } catch (err) {
      console.log(err);
    }
  } else {
    // 不调接口
    // ElMessage.success('Logout Successful!')
    // localStorage.removeItem('authorization')
    // localStorage.removeItem('userInfo')
    // localStorage.removeItem('user_id')
    // store.commit('setModalStatus', '1')
    // store.commit('setLoginStatus', false)
    // localStorage.removeItem('token')
    // store.commit('setIsDemo', null)
    // store.commit('setHashValue', null)
    // // store.commit("setIsDemo", 0);
    // // 清空vuex的缓存
    // store.commit('getUserInfo', {})
    // store.commit('getDeviceInfo', [])
    // store.commit('setSubscripts', {})
    // store.commit('setCurrentDeviceInfo', {})
    // router.go(0)
    signout()
      .then((res) => {
        if (res.data.code == "200") {
          ElMessage.success(t("logoutSucceeded"));
          localStorage.removeItem("authorization");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("user_id");
          store.commit("setModalStatus", "1");
          store.commit("setLoginStatus", false);
          localStorage.removeItem("token");
          store.commit("setIsDemo", null);
          store.commit("setHashValue", null);
          // store.commit("setIsDemo", 0);
          // 清空vuex的缓存
          store.commit("getUserInfo", {});
          store.commit("getDeviceInfo", []);
          store.commit("setSubscripts", {});
          store.commit("setCurrentDeviceInfo", {});
          store.commit("setCurrentDeviceId", 0);
          router.go(0);
        }
      })
      .catch((err) => {
        console.log("退出失败", err);
      });
  }
};

// 去购买
const gotoPay = () => {
  store.commit("setPayFrom", 0);
  gaEvent("Buy_Page", {
    event_category: "Buy",
    event_label: "From_PurchaseNewPlan",
  });
  store.commit("setDefaultMenu", null);
  router.push({ path: "addDevice" });
};

// 点击logo跳转官网
const official = () => {
  window.open("https://www.famikeep.com/", "_blank");
};

const currentDeviceId = computed(() => store.state.currentDeviceInfo.id);
// 删除数据
const emptyData = async () => {
  try {
    const res = await emptyDataApi(currentDeviceId.value);
    if (res.data.code == 200) {
      location.reload();
    } else {
      ElMessage.error(res.data.message);
    }
  } catch (err) {
    console.log(err);
    ElMessage.error(err.message);
  }
};

// j解绑设备并删除该设备的所有数据
const unbindAndEmptyData = async () => {
  // console.log('unbindAndEmptyData');
  try {
    const res = await unbindAndEmptyDataApi(currentDeviceId.value);
    // console.log('res', res)
    if (res.data.code == 200) {
      await refreshTab();
      // store.commit('setCurrentDeviceId', null)
      // store.commit('setCurrentDeviceInfo')
      location.reload();
    } else {
      ElMessage.error(res.data.message);
    }
  } catch (err) {
    console.log(err);
    ElMessage.error(err.message);
  }
};

const deviceList = computed(() => store.state.deviceInfo);
const refreshTab = async () => {
  await store.dispatch("getUserInfo");
  await store.dispatch("getDeviceInfo");
  if (store.state.deviceInfo.length > 0) {
    store.commit("setBoundImg", false);
    if (store.state.deviceInfo[0].id) {
      store.commit("setCurrentDeviceId", store.state.deviceInfo[0].id);
      store.commit("setCurrentDeviceInfo", store.state.deviceInfo[0]);
    } else {
      store.commit("setCurrentDeviceId", store.state.deviceInfo[0].devices[0].id);
      store.commit("setCurrentDeviceInfo", { ...store.state.deviceInfo[0].devices[0], is_expired: store.state.deviceInfo[0].is_expired, expire_at: store.state.deviceInfo[0].expired_at });
    }
  } else {
    // debugger
    // console.log('wwwwwwwwwwww')
    store.commit("setDefaultMenu", null);
    router.push({ path: "/guide" });
    store.commit("setCurrentDeviceId", "Device 1");
    store.commit("setCurrentDeviceInfo", {
      name: "leftTab.unboundName",
      id: "Device 1",
      model: "leftTab.unbound",
    });
    store.commit("setBoundImg", true);
  }
  store.dispatch("updateMenuList", {
    deviceInfo: deviceInfo.value,
    getCurrent: false,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", _hoisted_2, [
      _createElementVNode("div", {
        class: "aside_left",
        onClick: official
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "purchase",
          onClick: gotoPay
        }, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("leftTab.purchase")), 1)
          ])
        ]),
        _createVNode(_component_el_popover, {
          placement: "bottom",
          width: 480,
          trigger: "click",
          "popper-class": "userPop"
        }, {
          reference: _withCtx(() => [
            _createElementVNode("div", {
              class: "user",
              onClick: showUser
            }, [
              (userInfo.value.profile_picture_url)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("img", {
                      class: "headerAvator",
                      src: userInfo.value.profile_picture_url,
                      alt: ""
                    }, null, 8, _hoisted_10)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: _normalizeClass(isDemoRef.value ? 'demoStyle' : '')
              }, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("user.userProfile")), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("user.usesrname")), 1),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(userInfo.value.name), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(isDemoRef.value ? 'changeColor' : 'right'),
                        onClick: modifyName
                      }, _toDisplayString(_ctx.$t("user.edit")), 3)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("user.email")), 1),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(userInfo.value.email), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    onClick: showAvatar,
                    class: "userAvatar"
                  }, [
                    (userInfo.value.profile_picture_url)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("img", {
                            class: "avator",
                            src: userInfo.value.profile_picture_url,
                            alt: ""
                          }, null, 8, _hoisted_27)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30)),
                    _hoisted_31
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("user.permission")), 1),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("user.bounded")), 1),
                    _createElementVNode("span", _hoisted_37, _toDisplayString(subscriptsIsNull.value ? "--" : _unref(boundedDevice)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("user.restDevice")), 1),
                    _createElementVNode("span", _hoisted_41, _toDisplayString(subscriptsIsNull.value ? "--" : _unref(restDevice)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t("user.expire")), 1),
                    _createElementVNode("span", _hoisted_45, _toDisplayString(subscriptsIsNull.value ? "--" : _unref(expiration)), 1),
                    (expired.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.$t("user.expired")), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(loginOut) && _unref(loginOut)(...args))),
                class: _normalizeClass(["logout", isDemoRef.value ? 'demoStyle' : ''])
              }, [
                _hoisted_47,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("user.logout")), 1)
              ], 2)
            ])
          ]),
          _: 1
        }),
        _createVNode(languageChange, { send: 0 })
      ])
    ]),
    (clickModify.value)
      ? (_openBlock(), _createBlock(ChangeName, {
          key: 0,
          visible: clickModify.value,
          onSaveName: saveUserName
        }, null, 8, ["visible"]))
      : _createCommentVNode("", true),
    (clickAvatar.value)
      ? (_openBlock(), _createBlock(ChangeAvator, {
          key: 1,
          onSaveAvatar: saveAvatar,
          visible: clickAvatar.value
        }, null, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})